<template>
	<slideover
		:title="editing?.notes ? 'Edit Note' : 'Add Note'"
		:open="editing !== null"
		:actions="[
			{
				text: 'Save',
				disabled: !valid,
				method: saveNote,
				icon: 'save'
			}
		]"
		@close="close">
		<app-input v-if="editing" v-model="editing!.notes" name="notes" type="textarea" />
	</slideover>
</template>

<script lang="ts" setup>
	import { ref, watch, computed } from 'vue'
	import { Collection } from '@/data/schema/collection'
	import CollectionService from '@/services/collection'
	import useToaster from '@/stores/toaster'

	const api = new CollectionService()
	const toaster = useToaster()
	const editing = ref<Collection | null>(null)

	const props = withDefaults(
		defineProps<{
			collection?: Collection | null
		}>(),
		{
			collection: null
		}
	)

	const valid = computed(() => {
		return editing.value?.notes
	})

	const saveNote = () => {
		toaster.working({
			text: 'Saving note...',
			timeout: 0,
			dismissable: false
		})

		api.updateCollection(editing.value!.collection_number, { notes: editing.value!.notes })
			.then(() => {
				toaster.clear()
				toaster.success({
					text: 'Note saved successfully'
				})
				emit('updated', editing.value!.notes)
				close()
			})
			.catch((error) => {
				console.log(error)
				toaster.clear()
				toaster.error({ text: 'Error occurred updating note' })
			})
	}

	function close() {
		editing.value = null
		emit('closed')
	}

	watch(
		() => props.collection,
		(newVal) => {
			editing.value = newVal ?? null
		}
	)

	// Events
	const emit = defineEmits(['updated', 'closed'])
</script>
